import { createMongoAbility, MongoAbility } from '@casl/ability'
import { useSelector } from 'react-redux'

const useAbilityStore = (): MongoAbility => {
  const abilityInstance = useSelector(
    (state: { global: { ability: MongoAbility } }) => state?.global?.ability
  )

  // TODO we need to allign how to allign this with tests, tests will suppose to have some abilities
  return (
    abilityInstance ||
    createMongoAbility([
      {
        action: 'view',
        subject: 'Resident',
      },
      {
        action: 'create',
        subject: 'Resident',
      },
      {
        action: 'update',
        subject: 'Resident',
      },
    ])
  )
}

export default useAbilityStore
